export default __webpack_public_path__ + "static/media/logo.6ec6c864.svg";